import React, { forwardRef } from "react";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@mui/icons-material";

export const config = (userToken) => ({
  headers: {
    Authorization: `Bearer ${userToken}`,
    "Content-Type": "application/json",
  },
});

export const tableColumns = (worker) => [
  { title: "Bil", field: "car" },
  {
    title: "Chaufför/Driver",
    field: "worker",
    lookup: worker,
  },
  {
    title: "Personal 2",
    field: "coworker",
    lookup: worker,
  },
  { title: "kl", field: "info" },
  { title: "ID", field: "ord" },
  { title: "kl", field: "infoSecond" },
  { title: "ID", field: "ordSecond" },
  { title: "Anteckningar", field: "note" },
];
export const tableWorkersColumns = () => [
  { title: "Namn", field: "name" },
  {
    title: "Semester",
    field: "holiday",
    type: "boolean",
    render: rowData => (
      <input
        type="checkbox"
        checked={rowData.holiday}
        disabled={rowData.sick}
        onChange={(e) => {
          rowData.holiday = e.target.checked;
          // Update the state or call a function to handle the change
        }}
      />
    ),
    editComponent: props => (
      <input
        type="checkbox"
        checked={props.value}
        disabled={props.rowData.sick}
        onChange={e => props.onChange(e.target.checked)}
      />
    )
  },
  {
    title: "Sjuk",
    field: "sick",
    type: "boolean",
    render: rowData => (
      <input
        type="checkbox"
        checked={rowData.sick}
        disabled={rowData.holiday}
        onChange={(e) => {
          rowData.sick = e.target.checked;
          // Update the state or call a function to handle the change
        }}
      />
    ),
    editComponent: props => (
      <input
        type="checkbox"
        checked={props.value}
        disabled={props.rowData.holiday}
        onChange={e => props.onChange(e.target.checked)}
      />
    )
  }
];

export const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

export const BACKEND_URL = "https://sugbil-planning.onrender.com";
// export const BACKEND_URL = "http://localhost:8000";
